import { render, staticRenderFns } from "./ChatWidgetSettingsPopoutApp.vue?vue&type=template&id=b98b4340"
import script from "./ChatWidgetSettingsPopoutApp.vue?vue&type=script&lang=js"
export * from "./ChatWidgetSettingsPopoutApp.vue?vue&type=script&lang=js"
import style0 from "./ChatWidgetSettingsPopoutApp.vue?vue&type=style&index=0&id=b98b4340&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports